import {graphql} from 'gatsby';
import htmlReactParser, {domToReact} from 'html-react-parser';
import React, {Fragment, memo} from 'react';
import {useIntl} from 'react-intl';

import style from './intl-string-html.module.scss';
import Link from './link';

export const query = graphql`
	fragment IntlStringHtml on IntlStringHtml {
		de {
			html
		}
		en {
			html
		}
	}
`;

export default memo(
	/**
	 * @param {{
	 *   replaceLinks?: boolean,
	 *   userText?: boolean,
	 *   de: {
	 *     html: string,
	 *   },
	 *   en?: null | {
	 *     html: string,
	 *   },
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function IntlStringHtml({
		replaceLinks = true,
		userText = true,
		...props
	}) {
		const intl = useIntl();

		const parseOptions = {
			/**
			 * @param {import("html-react-parser").DomElement} node
			 * @returns {React.ReactElement | undefined} ...
			 */
			replace(node) {
				if (
					replaceLinks &&
					node.type === 'tag' &&
					node.name === 'a' &&
					node.attribs !== undefined &&
					node.attribs.href !== undefined
				) {
					return (
						<Link
							href={node.attribs.href}
							addExternalIcon={true}
						>
							{node.children && domToReact(node.children, parseOptions)}
						</Link>
					);
				}

				return undefined;
			},
		};

		const reactElems = htmlReactParser(
			intlStringHtml(intl, props).__html,
			parseOptions,
		);

		if (userText) {
			return (
				<div className={style.userText}>
					{reactElems}
				</div>
			);
		} else {
			return (
				<Fragment>
					{reactElems}
				</Fragment>
			);
		}
	}
);

/**
 * @param {import("react-intl").IntlShape} intl
 * @param {{
 *   de: {
 *     html: string,
 *   },
 *   en?: null | {
 *     html: string,
 *   }
 * }} intlStrHtml
 * @returns {{__html: string}} ...
 */
export function intlStringHtml(intl, intlStrHtml) {
	if (intl.locale === 'en' && !!intlStrHtml.en && !!intlStrHtml.en.html) {
		return {
			__html: intlStrHtml.en.html,
		};
	}
	return {
		__html: intlStrHtml.de.html,
	};
}
